import { render } from "./Studentssettledtable.vue?vue&type=template&id=6071a318&scoped=true"
import script from "./Studentssettledtable.vue?vue&type=script&lang=js"
export * from "./Studentssettledtable.vue?vue&type=script&lang=js"

import "./Studentssettledtable.vue?vue&type=style&index=0&id=6071a318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6071a318"]])

export default __exports__